import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './Profile.module.scss';
import ButtonLink from '@hiredigital/ui/Button/NextButtonLink';

const Availability = memo(({ user, hasToken }) => {
  return (
    <div className={classNames(Styles.section, Styles.ctaSection)}>
      <p className={Styles.ctaContent}>
        <span className={Styles.greenDot} />
        <span>{`${user.firstName} is `}</span>
        <span className={Styles.isAvailable}>{` Available `}</span>
        {`for Projects`}
      </p>

      {hasToken ? (
        <ButtonLink
          className={Styles.ctaButton}
          type={ButtonLink.Type.DARKBLUE}
          title='Work With Talent'
          href={`${process.env.NEXT_PUBLIC_SITE_URL}/login?next=${encodeURIComponent(
            process.env.NEXT_PUBLIC_APP_URL + `/briefs/`
          )}`}
          external>
          {`Work with ${user.talentAvailable ? user.firstName : `Talent like ` + user.firstName}`}
        </ButtonLink>
      ) : (
        <ButtonLink
          className={Styles.ctaButton}
          type={ButtonLink.Type.DARKBLUE}
          title='Work With Talent'
          href={{
            pathname: '/get-started',
            query: { talentName: user.username },
          }}>
          {`Work with ${user.firstName}`}
        </ButtonLink>
      )}
    </div>
  );
});

Availability.propTypes = {
  className: PropTypes.string,
};

export default Availability;
